import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ContractInterventionType {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: ContractInterventionType = {
  data: [],
  isLoading: false,
  error: null,
};

const contractInterventionTypeSlice = createSlice({
  name: 'contractInterventionType',
  initialState,
  reducers: {
    setContractInterventionTypes: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setContractInterventionTypeLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setContractInterventionTypeError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setContractInterventionTypes, setContractInterventionTypeLoading, setContractInterventionTypeError } =
  contractInterventionTypeSlice.actions;

export default contractInterventionTypeSlice.reducer;
